import AssessmentsAdapter from './base';
import {
  deleteRecordWithAuditReason,
  updateRecordWithAuditReason,
} from '@linc-technologies/linced-common/utils/auditing';

export default class Grade extends AssessmentsAdapter {
  modelNamePlural = 'grades';
  deleteRecord = deleteRecordWithAuditReason;
  updateRecord = updateRecordWithAuditReason;
}
